<template>
  <ion-app>
    <ion-content>
      <v-container fluid id="brandList">
        <div class="van-hairline--bottom van-nav-bar" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
          <div class="van-ellipsis van-nav-bar__title">{{ $t("brand.title") }}</div>
        </div>

        <div class="background_color_ffffff">
          <van-row gutter="18" class="index_head padding_10">
            <van-col span="24" class="wc-search-box font_12">
              <wc-search-box :placeholder="$t('brand.search')" @input="onClickSearch" />
              <br />
            </van-col>
          </van-row>
        </div>

        <v-data-iterator :items="brandList" :items-per-page="itemsPerPage" :page.sync="pageNo" hide-default-footer class="d-flex flex-column overflow-hidden">
          <template v-slot:no-data>
            <v-progress-linear indeterminate color="cyan"></v-progress-linear>
          </template>

          <template v-slot:default="props">
            <v-row dense align="center" align-content="center">
              <v-col v-for="item in props.items" :key="item.name" cols="4" md="3" lg="2" xl="2" @click="onClickBrand(item)">
                <v-card flat class="card fill-height">
                  <div class="brand_info">
                    <div class="brand_image">
                      <img v-lazy="item.LogoPath" />
                    </div>
                    <label class="brand_title">{{ item.Title }}</label>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <template v-slot:footer v-if="numberOfPages > 1">
            <wc-list-footer v-model="pageNo" :maxPage="numberOfPages" />
            <!-- <v-row class="no-gutters mt-auto py-2 shrink" align="center" justify="center">
              <span class="mr-4 grey--text">
                Page <span v-text="pageNo" class="font-weight-bold primary--text"></span> of {{ numberOfPages }}
              </span>
              <v-btn small dark rounded color="blue darken-3" class="mr-1" v-show="pageNo > 1" @click="prevPage">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn small dark rounded color="grey" class="mr-1" v-show="pageNo <= 1">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn small dark rounded color="blue darken-3" class="ml-1" v-show="pageNo < numberOfPages" @click="nextPage">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn small dark rounded color="grey" class="ml-1" v-show="pageNo >= numberOfPages">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-row> -->
          </template>
        </v-data-iterator>
      </v-container>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      searchText: "",
      curBrand: null,
      brandList: [],

      pageNo: 1,
    };
  },
  computed: {
    // cols="4" sm="3" md="2"
    itemsPerPage() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 99;
        case "sm":
          return 99;
        case "md":
          return 3 * 4;
        case "lg":
          return 3 * 6;
        case "xl":
          return 3 * 6;
      }
    },
    numberOfPages() {
      return Math.ceil(this.brandList.length / this.itemsPerPage);
    },
  },
  activated() {
    // for keep-alive component
    this.$parent.curTab = 3;
    this.$parent.topTab = 0;
    this.$parent.handleScroll(null);
  },
  mounted() {
    // this.$store.commit("resetRouteCount");
    if (!this.$enableBrands) this.$router.push({ name: "home" });
    this.$parent.curTab = 3;
    this.$parent.topTab = 0;
    this.loadStates();
    this.getBrandList();
  },
  methods: {
    // ------------------------------------------------------------------------ nextPage
    nextPage() {
      if (this.pageNo < this.numberOfPages) {
        this.pageNo += 1;
        this.$scrollTop();
      }
    },
    // ------------------------------------------------------------------------ prevPage
    prevPage() {
      if (this.pageNo > 1) {
        this.pageNo -= 1;
        this.$scrollTop();
      }
    },
    // ------------------------------------------------------------------------ loadStates
    loadStates() {
      if (this.$store.state.brandList) {
        if ("search" in this.$store.state.brandList) {
          this.searchText = this.$store.state.brandList.search;
        }
        if ("brand" in this.$store.state.brandList) {
          this.curBrand = this.$store.state.brandList.brand;
        }
      }
    },
    // ------------------------------------------------------------------------ saveStates
    saveStates() {
      let $this = this;
      $this.$store.commit("brandList", {
        search: $this.searchText,
        brand: $this.curBrand,
      });
    },
    // ------------------------------------------------------------------------ onClickSearch
    onClickSearch(data) {
      let $this = this;
      $this.searchText = data.toUpperCase();
      $this.getBrandList();
    },
    // ------------------------------------------------------------------------ getBrandList
    getBrandList() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        title: $this.searchText,
      };
      $this.brandList = [];
      $this.$ajax2
        .post("GetBrand", obj, $this.$ajaxHeader)
        .then(function (rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.brandList = rpdata.data.data;
          }
        }).catch(function (err) { }); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickBrand
    onClickBrand(data) {
      let $this = this;
      $this.saveStates();
      $this.$store.commit("brandProductList", { brand: data, routeBack: true });
      // this.$store.commit("incRouteCount");
      $this.$router.push({ name: "brandProductList", params: { code: data.Id } });
    },
  },
};
</script>

<style>
#brandList {
  width: 100%;
}

#brandList .brand_info {
  max-height: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  text-align: center;
  padding: 0px;
}

#brandList .brand_info .brand_title {
  font-size: 10px;
  text-align: center;
  width: 100%;
}

/* #brandList .brand_info .brand_image {
  border: 1px solid black;
} */
#brandList .brand_info .brand_image img {
  display: block;
  max-height: 100%;
  max-width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

/*
.brand_image {
  position: relative;
  width: 100%;
  vertical-align: middle;
}
.brand_image:before {
  content: "";
  display: block;
  padding-top: 80%;
}
.brand_image img {
  position: absolute;
  top: 5%;
  left: 5%;
  bottom: 0%;
  right: 0%;
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;
}
*/

/*
#brandList .van-col--9 {
  width: 33%;
}
#brandList .van-hairline--top-bottom::after {
  border-width: 0;
}
*/
/* #brandList .index_head {
  margin-left: 16px !important;
  margin-right: 0px !important;
  height: 44px;
} */
</style>
